import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import YoutubeModal from 'components/Modal/YoutubeModal/YoutubeModal'

import useSizeDetector from 'hooks/useSizeDetector'

import Description from '../../components/Description/Description'
import TopBar from '../../components/TopBar/TopBar'

import playIcon from './i/play.svg'

import { getVideoData } from './utils'

import styles from './Contacts.module.scss'

const Contacts = ({
    descriptionTitle,
    currentStep,
    stepsCount,
    onNext,
    nextButtonText,
    isBusiness,
    selectedInterests,
}) => {
    const { ref: sizeDetectorRef, width } = useSizeDetector()

    const { t } = useTranslation()
    const [video, setVideo] = useState(null)
    const [isOpenedModal, setIsOpenedModal] = useState(false)

    useEffect(() => {
        setVideo(getVideoData(isBusiness, selectedInterests))
    }, [selectedInterests, isBusiness])

    return (
        <div className={styles.contacts}>
            <TopBar
                currentStep={currentStep}
                stepsCount={stepsCount}
                isCanGoNext
                onNext={onNext}
                nextButtonText={nextButtonText}
            />
            <Description
                title={descriptionTitle}
                subTitle={t('Our Help Center and YouTube channel are also at your service:')}
                isAddContacts
                width={340}
            />
            {!!video && (
                <>
                    <div className={styles.contactsVideo} ref={sizeDetectorRef} style={{ height: (width * 9) / 16 }}>
                        <div className={styles.imageBox} onClick={() => setIsOpenedModal(true)}>
                            <img src={video.cover} alt="cover" />
                            <div className={styles.button}>
                                <img src={playIcon} alt="play" />
                            </div>
                        </div>
                    </div>
                    {isOpenedModal && (
                        <YoutubeModal
                            title={t('How to build your first project')}
                            onClose={() => setIsOpenedModal(false)}
                            videoId={video.id}
                        />
                    )}
                </>
            )}
        </div>
    )
}

export default Contacts
